import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";

export const AuthLogin = async (
  email: string,
  password: string
): Promise<string> => {
  const auth = getAuth();
  const usercre = await signInWithEmailAndPassword(auth, email, password);

  await auth.authStateReady();
  const user = usercre.user;
  const token = await user.getIdToken(true);
  localStorage.setItem("jwt", token);
  return token;
};

export const AuthReload = async (): Promise<string> => {
  localStorage.removeItem("jwt");
  const auth = getAuth();
  await auth.authStateReady();
  const user = auth.currentUser;
  if (user) {
    await user.reload();
    const token = await user.getIdToken(true);
    localStorage.setItem("jwt", token);
    return token;
  }
  return "";
};

export const AuthLogout = async (): Promise<void> => {
  const auth = getAuth();
  await signOut(auth);
};
